import React, {useState, useContext, useEffect} from "react";
import { LogoContext } from "../../contexts/LogoContext";

const InputLogo = (props) => {
    const [logo,setLogo] = useState("");
    const {logos,dispatch} = useContext(LogoContext);
    const handleChange = (e) => setLogo(e.target.value);
    
    useEffect(() => {
        dispatch({ type: 'UPDATE_LOGO', name: logo })
    }, [logo])

    const localStyleObj = {
        width: `${logos.localWidth}%`
    }
    const webStyleObj = {
        width: `${logos.webWidth}%`
    }
    return logos.dropdown === 'typed' ||
          (logos.dropdown === 'local' && logos.localUrl === '') || 
          (logos.dropdown === 'web' && logos.webUrl === '') ? (
        <div className='input-details'>
            <input onChange={handleChange} 
                placeholder={props.logo}
                style={props.logoStyleObj} />
        </div>
    ) : logos.dropdown === 'local' ? 
        <img className='logo-local' src={logos.localUrl} style={localStyleObj} alt={logos.localUrl}/>
    : <img className='logo-web' src={logos.webUrl} style={webStyleObj} alt={logos.webUrl}/>
};

export default InputLogo;
